/**
 * Analytics — Phase 14 shell.
 *
 * Three tabs (Destinations, Monthly Revenue, Lead Conversion) — each tab
 * lives in `components/analytics/*Tab.js` to keep individual modules small
 * enough for the visual-edits Babel plugin to parse without recursion.
 */
import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { LineChart, MapPin, TrendingUp, Users as UsersIcon } from 'lucide-react';
import DestinationsTab from '@/components/analytics/DestinationsTab';
import MonthlyRevenueTab from '@/components/analytics/MonthlyRevenueTab';
import LeadConversionTab from '@/components/analytics/LeadConversionTab';

const Analytics = () => (
  <div className="space-y-6 p-6 max-w-7xl mx-auto" data-testid="analytics-page">
    <header>
      <h1 className="text-2xl font-semibold text-slate-900 flex items-center gap-2">
        <LineChart className="h-6 w-6 text-emerald-600" />
        Analytics
      </h1>
      <p className="text-sm text-slate-500 mt-0.5">
        Destinations, monthly revenue, and lead-conversion insights.
      </p>
    </header>

    <Tabs defaultValue="destinations" className="w-full">
      <TabsList className="bg-slate-100/80 p-1 rounded-xl" data-testid="analytics-tabs">
        <TabsTrigger value="destinations" className="rounded-lg data-[state=active]:bg-white data-[state=active]:shadow-sm gap-2" data-testid="tab-destinations">
          <MapPin className="h-4 w-4" /> Destinations
        </TabsTrigger>
        <TabsTrigger value="monthly" className="rounded-lg data-[state=active]:bg-white data-[state=active]:shadow-sm gap-2" data-testid="tab-monthly-revenue">
          <TrendingUp className="h-4 w-4" /> Monthly Revenue
        </TabsTrigger>
        <TabsTrigger value="conversion" className="rounded-lg data-[state=active]:bg-white data-[state=active]:shadow-sm gap-2" data-testid="tab-lead-conversion">
          <UsersIcon className="h-4 w-4" /> Lead Conversion
        </TabsTrigger>
      </TabsList>

      <TabsContent value="destinations" className="mt-6"><DestinationsTab /></TabsContent>
      <TabsContent value="monthly" className="mt-6"><MonthlyRevenueTab /></TabsContent>
      <TabsContent value="conversion" className="mt-6"><LeadConversionTab /></TabsContent>
    </Tabs>
  </div>
);

export default Analytics;
